import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BookmarksService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  setBookmark(documentId: number): Observable<any> {
    const url = this.apiData.apiURL + `api/${this.client}/bookmark/document/${documentId}`;
    return this.http.post<any>(url, {});
  }

  deleteBookmark(documentId: number): Observable<any> {
    const url = this.apiData.apiURL + `api/${this.client}/bookmark/document/${documentId}`;
    return this.http.delete<any>(url);
  }
}
